export const SIDEBAR_GAME_TAB = 'game';
export const SIDEBAR_PLAY_TAB = 'play';
